import { styled } from '@nykaa/ui-components';
import { FOCUS_VISIBILITY_CSS, MOBILE_NAVIGATION_HEIGHT } from 'shared/styles/base';
import { BOTTOM_NAV_HEIGHT } from 'shared/styles/base';
import { Shimmer as BaseShimmer, ShimmerAvatar as BaseShimmerAvatar } from 'shared/styles/mixin';

interface ShimmerProps {
  shimmerWidth: string | number;
  shimmerHeight: string | number;
}

export const FooterContainer = styled.div`
  background-color: black;
  display: flex;
  flex-direction: column;
  width: 100vw;
  align-items: center;
  margin: 0;
  margin-bottom: ${MOBILE_NAVIGATION_HEIGHT + 18}px;
  padding: ${({ theme }) => theme.spacing.spacing100};
`;

export const Container = styled.div`
  margin-bottom: ${BOTTOM_NAV_HEIGHT}px;
  padding: ${({ theme }) => theme.spacing.spacing100};
  padding-bottom: 0;
  overflow-y: hidden;
  overflow-x: hidden;
  color: ${({ theme }) => theme.colors.textPrimary};
  ${({ theme }) => theme.typography.bodyMedium};
`;

export const BlankSpace = styled.div`
  width: 100vw;
  height: 30px;
`;

export const ShimmerContainer = styled.div`
  width: 100vw;
  height: 1032px;
`;

export const Shimmer = styled(BaseShimmer) <ShimmerProps>`
  width: ${({ shimmerWidth }) => shimmerWidth}px;
  height: ${({ shimmerHeight }) => shimmerHeight}px;
`;

export const ShimmerAvatar = styled(BaseShimmerAvatar) <ShimmerProps>`
  width: ${({ shimmerWidth }) => shimmerWidth}px;
  height: ${({ shimmerHeight }) => shimmerHeight}px;
`;

export const ShimmerSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${({ theme }) => theme.spacing.spacing120};
  gap: 16px;

  &:first-child {
    margin-top: ${({ theme }) => theme.spacing.spacing100};
  }
`;

export const ShimmerSectionItem = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: ${({ theme }) => theme.spacing.spacing40};
  border-bottom: 1px solid ${({ theme }) => theme.colors.textOutline};
  &:last-child {
    border-bottom: none;
  }
`;

export const ShimmerSectionText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const ShimmerFooter = styled.div`
  width: 100vw;
  height: 370px;
  padding: ${({ theme }) => theme.spacing.spacing100};
  background-color: black;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  & > * {
    margin-bottom: ${({ theme }) => theme.spacing.spacing40};
    width: 25%;
  }
`;

export const ShimmerHeader = styled.div`
  width: 100%;
  display: flex;
  margin-bottom: ${({ theme }) => theme.spacing.spacing80};
  justify-content: space-between;
`;

export const ShimmerHeaderText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1px;
`;

export const ShimmerBody = styled.div`
  padding: ${({ theme }) => theme.spacing.spacing80};
`;

export const Box = styled(Shimmer) <ShimmerProps>`
  width: ${({ shimmerWidth }) => shimmerWidth};
  height: ${({ shimmerHeight }) => shimmerHeight}px;
`;

export const LogoutButton = styled.button`
  width: 100%;
  background-color: black;
  border: 1px solid ${({ theme }) => theme.colors.textInverseOutline};
  color: ${({ theme }) => theme.colors.textInversePrimary};
  padding: ${({ theme }) => `${theme.spacing.spacing60} 0`};
  ${({ theme }) => theme.typography.buttonLarge};

  ${FOCUS_VISIBILITY_CSS}

  &:focus-visible {
    outline-color: ${({ theme }) => theme.colors.secondary};
  }
`;

export const NykaaFashionIcon = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.spacing120};
  margin-top: ${({ theme }) => theme.spacing.spacing80};
`;
